module.exports = __webpack_public_path__ + "static/media/icone_face.37fa858f.svg";